<div class="treemap-card" [style.--treemap-target-height]="treemapTargetHeight">
  <header class="treemap-card__header" *ngIf="displayTitle || data?.title">
    <h4>{{ displayTitle || data.title }}</h4>
  </header>

  <div class="treemap-card__divider" *ngIf="displayTitle || data?.title"></div>

  <div class="treemap-card__legend" *ngIf="!hasError && legendItems.length > 0">
    <button
      *ngIf="showLeftArrow"
      class="treemap-card__scroll"
      type="button"
      (click)="scrollLegend('left')"
    >
      <
    </button>

    <div
      #legendContainer
      class="treemap-card__legend-list"
      (scroll)="updateArrowVisibility()"
    >
      <div
        *ngFor="let item of legendItems"
        class="treemap-card__legend-item"
        [class.treemap-card__legend-item--active]="activeLegend === item.name"
        [class.treemap-card__legend-item--dimmed]="activeLegend !== null && activeLegend !== item.name"
        (click)="toggleLegend(item.name)"
      >
        <span class="treemap-card__legend-swatch" [style.background-color]="item.color"></span>
        <span class="treemap-card__legend-label">{{ item.name }}</span>
      </div>
    </div>

    <button
      *ngIf="showRightArrow"
      class="treemap-card__scroll"
      type="button"
      (click)="scrollLegend('right')"
    >
      >
    </button>
  </div>

  <div class="treemap-card__body">
    <div [class.hidden]="hasError" class="treemap-card__chart-shell">
      <div [id]="widgetId" class="treemap-card__chart"></div>
    </div>
  </div>

  <ng-template [ngIf]="hasError">
    <app-data-error [message]="errorMessage" />
  </ng-template>
</div>
